import _ from 'underscore';
import { AssetType, AssetEventOperationName } from './constants';

export const getCopilotRecommendationIdsFromThemes = (themeRecommendations) => {
  const themes = _.isArray(themeRecommendations) ? themeRecommendations : themeRecommendations.themes;

  const themeRecommendationIds = [];
  const imageRecommendationIds = [];
  const descriptionRecommendationIds = [];
  const headlineRecommendationIds = [];
  const longHeadlineRecommendationIds = [];

  if (themes) {
    _.map(themes, (theme) => {
      themeRecommendationIds.push(theme.id);
      if (theme.images) {
        imageRecommendationIds.push(...theme.images.map(v => v.suggestionId));
      }
      if (theme.descriptions) {
        descriptionRecommendationIds.push(...theme.descriptions.map(v => v.RecommendationId));
      }
      if (theme.headlines) {
        headlineRecommendationIds.push(...theme.headlines.map(v => v.RecommendationId));
      }
      if (theme.longHeadlines) {
        longHeadlineRecommendationIds.push(...theme.longHeadlines.map(v => v.RecommendationId));
      }
    });
  }
  return {
    themeRecommendationIds, descriptionRecommendationIds, headlineRecommendationIds, longHeadlineRecommendationIds, imageRecommendationIds,
  };
};

export function getSuggestedIdsAndAssetType({
  themeSuggestionIds = [],
  textSuggestionIds = [],
  imageSuggestionIds = [],
  videoSuggestionIds = [],
}) {
  const SuggestionIds = [
    ...themeSuggestionIds,
    ...textSuggestionIds,
    ...imageSuggestionIds,
    ...videoSuggestionIds,
  ];

  const AssetTypes = new Array(themeSuggestionIds.length + textSuggestionIds.length + imageSuggestionIds.length + videoSuggestionIds.length);
  AssetTypes.fill(AssetType.THEME, 0, themeSuggestionIds.length);
  AssetTypes.fill(AssetType.TEXT, themeSuggestionIds.length, themeSuggestionIds.length + textSuggestionIds.length);
  AssetTypes.fill(AssetType.IMAGE, themeSuggestionIds.length + textSuggestionIds.length, themeSuggestionIds.length + textSuggestionIds.length + imageSuggestionIds.length);
  AssetTypes.fill(AssetType.VIDEO, themeSuggestionIds.length + textSuggestionIds.length + imageSuggestionIds.length, themeSuggestionIds.length + textSuggestionIds.length + imageSuggestionIds.length + videoSuggestionIds.length);
  return { SuggestionIds, AssetType: AssetTypes };
}

export function getSuggestedIdsAndAssetTypeFromAssetsRecommendation(assetsRecommendationData) {
  const {
    RecommendedAssets: {
      Themes,
      ShortHeadlines,
      LongHeadlines,
      Descriptions,
      ImageAssets,
      VideoAssets,
    },
  } = assetsRecommendationData;

  return getSuggestedIdsAndAssetType({
    themeSuggestionIds: _.pluck(Themes, 'RecommendationId'),
    textSuggestionIds: [
      ..._.pluck(ShortHeadlines, 'RecommendationId'),
      ..._.pluck(LongHeadlines, 'RecommendationId'),
      ..._.pluck(Descriptions, 'RecommendationId'),
    ],
    imageSuggestionIds: _.pluck(ImageAssets, 'RecommendationId'),
    videoSuggestionIds: _.pluck(VideoAssets, 'RecommendationId'),
  });
}

/**
 * Adapt the API response to the format expected by the UI for displaying and applying an image asset.
 * @param {Object} image - Image object returned by copilot recommendation APIs.
 * @returns {Object} Formatted theme object.
 */
export function getFormattedImage(image) {
  const { RecommendationId, Url } = image;
  return {
    fullUrl: Url,
    thumbnailSrc: Url,
    thumbnailUrl: Url,
    suggestionId: RecommendationId,
  };
}

/**
 * Adapt the API response to the format expected by the UI for applying the theme and asset recommendation.
 * @param {Object} theme - A theme object returned by GetAssetsRecommendation.
 * @returns {Object} Formatted theme object.
 */
export function getFormattedThemeForApplying(theme) {
  return {
    id: theme.RecommendationId,
    name: theme.Name,
    previewUrl: _.get(theme, ['Images', 0, 'Url']),
    headlines: theme.ShortHeadlines,
    longHeadlines: theme.LongHeadlines,
    descriptions: theme.Descriptions,
    images: _.map(theme.Images, getFormattedImage),
  };
}

export function getOperationName(requestType) {
  if (requestType === 'findSimilar') {
    return AssetEventOperationName.FIND_SIMILAR;
  }
  if (requestType === 'differentTone') {
    return AssetEventOperationName.DIFFERENT_TONE;
  }
  if (requestType === 'rewrite') {
    return AssetEventOperationName.REWRITE;
  }

  return undefined;
}
